import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import AppProviders from './AppProviders'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <React.StrictMode>
    <AppProviders />
  </React.StrictMode>,
  document.getElementById('root')
)

reportWebVitals()
